import { createRoot } from 'react-dom/client';
import * as React from 'react';
import './index.css';
import App from './App';

const Root: React.FC = () => {
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(<Root />);
